import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpAction } from '../studio-http-client/http-action.enum';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  apiService = inject(ApiService);

  getApiVersion() {
    const getURL = `api/Public/Version`;
    return this.apiService.invokeLSApi<{ version: string }>(getURL, HttpAction.Get);
  }
}
